import React, { createContext, useContext, useState } from 'react'
import { styled } from '@mui/material'
import { useSidebarState, Notification } from 'react-admin'
import AppBar from './AppBar'
import { ChatButton } from './ChatButton';
import { ChatbotProvider } from './ChatbotContext';
import { HasPermission } from 'src/helper/HasPermission';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  //backgroundColor: theme.palette.background.default,
  position: 'relative',
}))

const AppFrame = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto',
  backgroundColor: 'white',
}))

const ContentWithSidebar = styled('main')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  backgroundColor: '#F9F9FD',
}))

const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 2,
  padding: theme.spacing(3),
  // marginTop: "2em",
  //paddingLeft: 5,
}))

const AppStateContext = createContext();

const LayoutTopNav = ({ children, title, config, ...props }) => {
  const [open] = useSidebarState()
  const [customTitle, setCustomTitle] = useState('')

  const updateCustomTitle = (newValue) => setCustomTitle(newValue)

  return (
    <Root>
      <AppFrame>
        <ChatbotProvider>
          <AppStateContext.Provider value={{ customTitle, updateCustomTitle }}>
            <AppBar title={title} open={open} config={config} customTitle={customTitle} />
            <ContentWithSidebar>
              <Content>
                <Notification />
                {children}
              </Content>
            </ContentWithSidebar>
          </AppStateContext.Provider>
          <HasPermission resource={'application'} permission='chatbot'>
            <ChatButton/>
          </HasPermission>
        </ChatbotProvider>
      </AppFrame>
    </Root>
  )
}

export default LayoutTopNav

export function useAppState() {
  return useContext(AppStateContext);
}